import React from 'react';
import { Switch } from './ui/switch';
import { cn } from '@/lib/utils';

/**
 * Optional add-on card — title, description, toggle; sub-options expand inside the same card.
 */
const OptionToggleCard = ({
  title,
  description,
  priceBadge,
  checked,
  onCheckedChange,
  children,
  className,
}) => {
  const handleCardClick = () => {
    onCheckedChange(!checked);
  };

  return (
    <div
      className={cn(
        'rounded-2xl bg-white transition-all',
        checked ? 'border-2 border-gray-900 shadow-sm' : 'border border-gray-200 hover:border-gray-300',
        className
      )}
    >
      <div
        role="button"
        tabIndex={0}
        onClick={handleCardClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleCardClick();
          }
        }}
        className="flex cursor-pointer items-start justify-between gap-4 p-4"
      >
        <div className="min-w-0 flex-1 pr-2">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-base font-bold text-gray-900">{title}</span>
            {priceBadge ? (
              <span className="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-600">
                {priceBadge}
              </span>
            ) : null}
          </div>
          {description ? (
            <p className="mt-1 text-sm leading-snug text-slate-500">{description}</p>
          ) : null}
        </div>
        <div
          className="flex-shrink-0 pt-0.5"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Switch
            checked={checked}
            onCheckedChange={onCheckedChange}
            className={cn(
              'h-6 w-11 data-[state=checked]:bg-slate-800',
              !checked && 'border-2 border-amber-400/80 bg-gray-200 data-[state=unchecked]:bg-gray-200'
            )}
          />
        </div>
      </div>
      {checked && children ? (
        <div
          className="border-t border-gray-100 px-4 pb-4 pt-3"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default OptionToggleCard;
